module.exports = __webpack_public_path__ + "static/media/PAX.10adf1bf.svg";